import React from "react";
import { useNavigate } from "react-router-dom";
import "./comparisonTopTabs.css";

const ComparisonTopTabs = ({ activeTab }) => {
    const navigate = useNavigate();
    const topTabs = [
        { name: "SalesForce", path: "/comparison/salesforce" },
        { name: "Hubspot", path: "../comparison/hubspot" },
        { name: "Realty Redefined", path: "../comparison/realty-redefined" },
        { name: "Zoho", path: "../comparison/zoho" },
        { name: "Paramantra", path: "../comparison/paramantra" }
    ];
    const handleTopNavigation = (path) => {
        navigate(path);
    };

    return (
        <div className="comparison-tabs-container">
            <div className="container">
                <ul>
                    {topTabs.map((heading, index) => (
                        <li key={index} className={`${index === activeTab ? "active-heading" : ""}`} onClick={() => handleTopNavigation(heading.path)}>
                            {heading.name}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ComparisonTopTabs;
